import React from 'react';
import { Modal, Box, makeStyles, IconButton } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { TildelAnsvarlig } from './TildelAnsvarlig';
import type { TildelAnsvarligProps } from './TildelAnsvarligProps';
import { Typography } from '@klp/design/Typography';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import { useRoleMapping } from '@klp/leverandor/hooks';
import {
    leverandorActions,
    leverandorSelectors,
    isActiveModal,
} from '@klp/leverandor/store';
import { LeverandorRoutes } from '@klp/leverandor/config';

const useStyles = makeStyles((theme) => ({
    modal: {
        width: '90vh',
        maxWidth: '1000px',
        maxHeight: '90vh',
        overflowY: 'auto',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        borderRadius: '4px',
        outline: 'none',
        '&:focus': {
            outline: 'none',
        },
    },
    modalContent: {
        maxWidth: '100%',
        overflowX: 'hidden',
        wordWrap: 'break-word',
    },
    modalHeading: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));

export const TildelAnsvarligModal: React.FC<TildelAnsvarligProps> = ({
    superOfficeContactId,
    prosessInstansId,
    kandidatGruppe,
    currentAnsvarlig,
    activity,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const { activeModal } = useSelector(leverandorSelectors);
    const { handleMapping: handleRoleMapping } = useRoleMapping();

    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(leverandorActions.setActiveModal(undefined));
    };

    return (
        <Modal
            open={isActiveModal(activeModal, 'tildelAnsvarlig')}
            onClose={handleClose}
        >
            <Box className={classes.modal}>
                <Box className={classes.modalHeading}>
                    <Typography variant="h6">
                        {t('leverandor.table.tildelAnsvarlig.title')}:{' '}
                        {handleRoleMapping(kandidatGruppe)}
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <TildelAnsvarlig.Selector
                    superOfficeContactId={superOfficeContactId}
                    prosessInstansId={prosessInstansId!}
                    kandidatGruppe={kandidatGruppe}
                    currentAnsvarlig={currentAnsvarlig}
                    redirectTo={LeverandorRoutes.leverandorSchema()}
                    activity={activity}
                />
            </Box>
        </Modal>
    );
};
